<template>
    <div class="notification-actions">
        <button class="btn" @click="doResend">Переотправить</button>
        <button class="btn" @click="doMarkAsSent">Отметить как отправленное</button>
        <button class="btn btn--danger" @click="doSoftDelete">Мягкое удаление</button>
    </div>
</template>

<script setup lang="ts">
import { request } from '@/admin/shared/api/httpClient';

const props = defineProps<{ detail: { id: string } }>();

const notifId = (): string => String(props.detail.id);

async function doResend(): Promise<void> {
    if (!window.confirm('Переотправить уведомление?')) return;
    await request({
        method: 'post',
        url: `/admin-api/notifications/${notifId()}/resend/`,
        data: {},
    });
    window.alert('Уведомление поставлено в очередь на переотправку.');
    window.location.reload();
}

async function doMarkAsSent(): Promise<void> {
    const externalId = window.prompt('Введите внешний ID (необязательно):') ?? '';
    if (externalId === null) return;
    await request({
        method: 'post',
        url: `/admin-api/notifications/${notifId()}/mark-as-sent/`,
        data: { external_id: externalId },
    });
    window.location.reload();
}

async function doSoftDelete(): Promise<void> {
    if (!window.confirm('Мягко удалить уведомление? Действие необратимо.')) return;
    await request({
        method: 'post',
        url: `/admin-api/notifications/${notifId()}/soft-delete/`,
        data: {},
    });
    window.location.reload();
}
</script>

<style scoped>
.notification-actions {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-bottom: 1rem;
}

@media (max-width: 640px) {
    .notification-actions .btn { min-height: 2.5rem; }
}
</style>
